import { ReactNode } from "react"

const IconBadge = ({ children }: { children: ReactNode }) => {
    return (
        <div
            style={{
                height: "25px",
                width: "25px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#FFF4ED",
            }}
            className="r5"
        >
            {children}
        </div>
    )
}

export const ChipIcon = () => {
    return (
        <IconBadge>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="7" y="7" width="10" height="10" rx="2" stroke="#FF7A00" strokeWidth="2" />
                <rect x="10" y="10" width="4" height="4" fill="#FF7A00" />
                <path d="M12 2V5" stroke="#FF7A00" strokeWidth="2" />
                <path d="M12 19V22" stroke="#FF7A00" strokeWidth="2" />
                <path d="M2 12H5" stroke="#FF7A00" strokeWidth="2" />
                <path d="M19 12H22" stroke="#FF7A00" strokeWidth="2" />
                <path d="M5 5L7 7" stroke="#FF7A00" strokeWidth="2" />
                <path d="M17 17L19 19" stroke="#FF7A00" strokeWidth="2" />
                <path d="M17 7L19 5" stroke="#FF7A00" strokeWidth="2" />
                <path d="M5 19L7 17" stroke="#FF7A00" strokeWidth="2" />
            </svg>
        </IconBadge>
    )
}

export const WifiIcon = () => {
    return (
        <IconBadge>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 8C7.5 3.5 16.5 3.5 22 8" stroke="#FF7A00" strokeWidth="2" strokeLinecap="round" />
                <path d="M5 12C9 9 15 9 19 12" stroke="#FF7A00" strokeWidth="2" strokeLinecap="round" />
                <path d="M8 16C10.5 14.5 13.5 14.5 16 16" stroke="#FF7A00" strokeWidth="2" strokeLinecap="round" />
                <circle cx="12" cy="20" r="2" fill="#FF7A00" />
            </svg>
        </IconBadge>
    )
}

export const SignalIcon = () => {
    return (
        <IconBadge>
            <svg width="35" height="35" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" rx="10" fill="#FFF4ED" />
                <path d="M16 14C13.7909 16.2091 13.7909 19.7909 16 22" stroke="#FF7A00" strokeWidth="2.5" strokeLinecap="round" />
                <path d="M24 14C26.2091 16.2091 26.2091 19.7909 24 22" stroke="#FF7A00" strokeWidth="2.5" strokeLinecap="round" />
                <path d="M12.5 10.5C8.35786 14.6421 8.35786 21.3579 12.5 25.5" stroke="#FF7A00" strokeWidth="2.5" strokeLinecap="round" />
                <path d="M27.5 10.5C31.6421 14.6421 31.6421 21.3579 27.5 25.5" stroke="#FF7A00" strokeWidth="2.5" strokeLinecap="round" />
                <circle cx="20" cy="18" r="2" fill="#FF7A00" />
            </svg>
        </IconBadge>
    )
}

export const InfoIcon = () => {
    return (
        <IconBadge>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" rx="10" fill="#FFF4ED" />
                <circle cx="20" cy="20" r="10" stroke="#FF7A00" strokeWidth="2" />
                <circle cx="20" cy="15" r="1.5" fill="#FF7A00" />
                <path d="M20 19V25" stroke="#FF7A00" strokeWidth="2" strokeLinecap="round" />
            </svg>
        </IconBadge>
    )
}
